// Backend base URL. In production the API is served from the same domain as the site, so if the visitor
// arrived on an alias host (e.g. www.hupleyhuat.com while the build points at hupleyhuat.com) we call the
// API on the current origin instead — otherwise the request is cross-origin and blocked by CORS ("Network error").
const configured = process.env.REACT_APP_BACKEND_URL;

function resolve() {
  if (typeof window === "undefined" || !configured) return configured;
  try {
    const target = new URL(configured).hostname.replace(/^www\./, "");
    const here = window.location.hostname.replace(/^www\./, "");
    if (here === target && window.location.origin !== configured) return window.location.origin;
  } catch (err) { console.warn("Backend URL check skipped:", err?.message); }
  return configured;
}

export const BACKEND_URL = resolve();
